import { render, staticRenderFns } from "./Voltage.vue?vue&type=template&id=379b1a99"
import script from "./Voltage.vue?vue&type=script&lang=js"
export * from "./Voltage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports